import InsuranceBroker from './InsuranceBroker'

export default InsuranceBroker
